<template>
	<div class="goods-form-wrapper">
		<div class="header-sidebar m-0" slot="header">
			<h4 class="pull-left m-0">
				{{
				editRequest?$t('incomes.create.edit-request'):$t('incomes.create.create-request') }}

			</h4>
			<b-button class="pull-right mt-0 close-btn" @click="cancel" type="button" variant="link"><i
				class="fa fa-close"></i></b-button>
			<div class="clearfix"></div>
		</div>
		<div class="row bg-light pt-2" style="display: flex;justify-content:space-between">
			<div class="col-3">
				<b-form>
					<multiselect
				 	:show-labels="false"
					track-by="id"
					label="name"
					:placeholder="$t('promo-to-product.department')"
					v-model="filter.contragent"
					:options="transferPermittedDepartments"
					:searchable="true"
					class="multiselect-pricing"
					>
				 </multiselect>
				</b-form>

			</div>
			<div class="col-3">
				<b-button block variant="primary" size="sm" @click="filterPage">{{$t('incomeFilter.search')}}</b-button>
			</div>
			<div class="col-3">
				<b-button block variant="info" size="sm"
				@click="clickRequest('SUSPEND')">
				{{$t('save')}}</b-button>
			</div>
			<div class="col-3">
				<b-button block variant="success" size="sm"
				@click="clickRequest('PENDING')">Отправить заявку</b-button>
			</div>
		</div>

		<div class="row bg-light pt-1 pb-1" style="display: flex;justify-content:space-between"  v-if="isFilterOpen">
			<div class="col-3">
					<b-form-select
					size="sm"
					v-model="filter.brandId"
				>
					<option v-for="(selectOption, indexOpt) in brands"
						:key="indexOpt"
						:value="selectOption.id"
					>
						{{ selectOption.name }}
					</option>
					<template slot="first">
						<option :value="null">-- {{$t('goods.brand')}} --</option>
					</template>
				</b-form-select>
			</div>

			<div class="col-3">
				<b-form @submit="e => e.preventDefault()">
					<b-input-group size="sm">
					<b-form-input v-model="filter.barcode" v-on:keyup.enter="searchKeywordFilter('filter')" size="sm"
								  :placeholder="$t('goods.barcode')"/>
				</b-input-group>
				</b-form>
			</div>

			<div class="col-3">
				<b-form @submit="e => e.preventDefault()">
					<b-input-group size="sm">
					<b-form-input v-model="filter.name" v-on:keyup.enter="searchKeywordFilter('filter')" size="sm"
								  :placeholder="$t('goods.create.name')+'/'+$t('goods.artikul')"/>
				</b-input-group>
				</b-form>
			</div>
			<div class="col-3">
				<b-button @click="searchKeywordFilter('filter')" block variant="primary" size="sm">
					<i class="fa fa-search"></i>
					{{$t('contragent.filter')}}
				</b-button>
			</div>


		</div>
		<div class="row bg-light pb-1" v-if="isFilterOpen">
				<!-- PRODUCT SEARCH RESULT -->
				<b-col sm="12">
						<div id="searchResult"
						ref="searchResult"
						v-click-outside="hideSearchResult"
						:style="[items.length > 0 ? {'min-height': 'unset'} : {}]"
				>

					<with-keyboard-control-for-transfer
							v-if="items.length > 0"
							:listLength="items.length"
							@selected="selectedHandler"
							@escapeClicked="escapeClicked"
							:current-index="computedCurrentIndex"
							ref="withKeyboardControl"
							@check ="checkHasItem"
					>
						<template slot-scope="{selectedIndex}">
							<!-- <loading
								v-if="searchLoading"
								width="60px"
								height="60px"
							></loading> -->

							<div
								v-for="(item, index) in items"
								:class="{'dd': item.checked ? item.checked :checkedItems.indexOf(item) != -1}"
								:key="'searchItem' + index"
								@click="selectedHandler(index)"
							>
								<template>
									<b-row class="foundProduct">
										<b-col cols="1">
											<b-row>
												<b-col cols="8" class="p-0">
													<vs-checkbox :disabled="true" type="checkbox"
													v-model="item.checked" :vs-value="item.id" />
												</b-col>
												<b-col cols="4" class="p-0">
													<div class="mr-1">
														{{ page == 1 ?index + 1: (page*10)+index+1 }}
													</div>
												</b-col>
											</b-row>
										</b-col>
										<b-col cols="2" >
										<div >
											<strong>{{item.barcode}}</strong>
										</div>
										</b-col>
										<b-col cols="7" class="text-left">
											<div >
											<span >
												{{ item.name ? item.name : '' }} /
												<strong>{{ item.artikul }}</strong>
												/ {{ item.colorName }} /
												<strong>{{ item.size }}</strong>
											</span>
											</div>
										</b-col>
										<b-col cols="2">
										<div >
											<strong>{{item.brandName}}</strong>
										</div>
										</b-col>
									</b-row>
									<!-- <div class="productName mb-0 d-flex"> -->


										<!-- <div>
											<img
												class="posItemImage"
												:src="item.mainPhotoId ? imageUrl + item.mainPhotoId : `${publicPath}img/pos-images/default-thumbnail.jpg`"
												alt="itemImage"
											>
										</div> -->


									<!-- </div> -->
								</template>
							</div>
						</template>
					</with-keyboard-control-for-transfer>
					</div>
				</b-col>
				<b-col>
					<ul class="pagination mt-1" v-if="items.length>0">
						<li class="page-item">
							<a class="page-link" @click.prevent="prev" href="#">{{$t('pagination.prev')}}</a>
						</li>
						<li v-if="page != 1" class="page-item">
							<a class="page-link"  href="#">...</a>
						</li>
						<div v-for="(pag, index) in pagesTotal" :key="index">
							<li class="page-item" :class="{'active' : page == pag}"
							v-if="((pag < page) && (page - pag) < 3 ) || ((pag > page) && (pag - page) < 3 )  || page == pag"
							><a class="page-link" @click.prevent="setPage(pag)" href="#">{{pag}}</a></li>
						</div>
						<li v-if="page != pagesTotal" class="page-item">
							<a class="page-link"  href="#">...</a>
						</li>
						<li  class="page-item">
							<a class="page-link" @click.prevent="next" href="#">{{$t('pagination.next')}}</a>
						</li>
					</ul>
				</b-col>
		</div>
		<div>
			<table class="table table-bordered mt-2" >
				<thead>
				<tr>
					<th style="width: 30px;text-align: center">№</th>
					<th style="width: 30%" class="pl-2">{{$t('sidebar.warehouse-management.products')}}</th>
					<th class="text-center">{{$t('goods.barcode')}}</th>
					<th style="width: 15%;text-align: center">{{$t('goods.color')}}</th>
					<th class="text-center">{{$t('goods.brand')}}</th>
					<th class="text-center">{{$t('incomes.create.count')}}</th>
					<th  class="text-center">{{$t('comment')}}</th>
					<th class="text-center">{{$t('prices.item.actions')}}</th>
					<!--<th style="width: 230px;">Количество</th>-->
				</tr>
				</thead>
				<tr v-for="(lostItem,index) in checkedItems" cols="12"
				:key="index"
				:class="{editBg:lostItem.edit}"
				>
					<td style="text-align: center">
						{{ index+1 }}
					</td>
					<td class="pl-2">{{lostItem.name}} <strong>{{ lostItem.artikul}}</strong>/{{lostItem.colorName}}
					</td>
					<td class="text-center">
						<strong>{{lostItem.barcode}}</strong>
					</td>
					<td style="text-align: center">
						{{ lostItem.colorName}}
					</td>
					<td style="text-align: center">
						{{ lostItem.brandName}}
					</td>

					<td style="width:20%">
						<b-col>
							<b-input-group size="sm">
								<b-form-input v-model="lostItem.count"
									size="sm"
									autocomplete="off" type="number"></b-form-input>
								<b-input-group-addon>
									<b-button size="sm" disabled>
										{{ lostItem.unitName }}
									</b-button>
								</b-input-group-addon>
							</b-input-group>
						</b-col>
					</td>
					<td>
						<b-form @submit="e => e.preventDefault()">
							<b-form-input
								class="p-3"
								size="sm"
								v-model="lostItem.comment"
								name="comment"
								autocomplete="off"
								:placeholder="$t('comment')"
							>
						</b-form-input>
						</b-form>
					</td>
					<td class="text-center trash" @click="deleteFromCheckedItems(index, lostItem)" style="width:8%">
						<i class="fa fa-trash fa-lg"></i>
					</td>
				</tr>
			</table>

			<b-row class="mt-4">
					<b-col sm="6"></b-col>
					<b-col sm="2">
						<label>{{ $t('comment') }}</label>
					</b-col>
					<b-col sm="4">
							<b-form-textarea
							style="height: 40px;"
							id="textarea"
							v-model="comment"
							:placeholder="$t('comment')"
							rows="3"

						></b-form-textarea>
					</b-col>
				</b-row>
		</div>
	</div>
</template>

<script>
import ContrAgentService from "../../services/contragent.service";
import ReferencesService from "../../services/references.sevice";
import {TokenService} from "../../services/storage.service";
import Multiselect from 'vue-multiselect'
import GoodsService from '../../services/goods.service'
import WithKeyboardControlForTransfer from "./with-keyboard-control"
import Vue from 'vue'
import {mapActions, mapGetters, mapState} from 'vuex'

export default {
		name: "createRequestItem",
		components: {Multiselect, WithKeyboardControlForTransfer},
		computed: {
			...mapGetters('departments', [
				'myDepartments','transferPermittedDepartments'
			]),
			...mapState('contragents',[ 'requestItems','editRequest']),
			...mapState('orderProduction', ['config']),
			computedCurrentIndex() {
				return this.currentIndex;
			},
		},
		data() {
			return {
				comment: '',
				hasItems:[],
				page: 1,
				current: 0,
				pagesTotal: 0,
				brands:[],
				uploadModal:false,
				item: null,
				mode: '',
				companyType: '',
				createModal: false,
				isFilterOpen: false,
				checkedItems: [],
				cartItems: [],
				currentIndex: 0,
				items: [],
				tableFilter: '',
				filter: {
					contragent: null,
					brandId: null,
					sezon: null,
					name: null,
					barcode: null
				},
				dropdowns: {
					department: [],
					counterparties: [],
					transferPermittedDepartments: [],
				},
				fields: [
					{
						key: 'id',
						label: 'ID',
						'class': 'min-30',
						visible: true,
						changebale: false
					},
					{

						key: 'itemName',
						label: this.$t('pos.product'),
						'class': 'noDefaultButton, width15_wordBreak',
					},

					{
						key: 'artikul',
						label: this.$t('goods.artikul'),
						'class': 'noDefaultButton, width15_wordBreak',
					},
					{
						key: 'barcode',
						label: this.$t('goods.barcode')
					},
					{
						key: 'colorName',
						label: this.$t('goods.color')
					},
					{
						key: 'brand',
						label: this.$t('goods.brand')
					},
					{
						key: 'actions',
						label: this.$t('actions.title'),
						'class': 'table_actions'
					}


				]
			}
		},
		watch: {
			'filter.brandId' : {
				handler(newValue) {

				}
			},
			checkedItems: {
				handler(newValue) {

				}
			}
		},
		methods: {
			...mapActions('orderProduction', ['sendForOrderProdutionData']),
			checkHasItem(checked) {
				if(checked == 'update') {
					this.items.forEach(el => {
					if(this.checkedItems.length> 0) {
						this.checkedItems.forEach(item => {
								if(item.id == el.id ) {
									Vue.set(el, "checked", true)
								}
							})
						}
					})
				}
				if(checked.checked) {
					this.items.forEach(el => {
						if(el.id === checked.id) {
							Vue.set(el, "checked", null)
						}
					})
				}
			},
			next() {
				if(this.pagesTotal > this.page) {
					this.page++
					this.searchKeywordFilter()
				}
			},
			prev() {
				if(this.page > 1) {
					this.page--
					this.searchKeywordFilter()
				}
			},
			async setPage(page) {
				this.page = page
				this.searchKeywordFilter()
			},


			async clickRequest(status) {
				if(this.filter.contragent) {
					if(this.checkedItems.length > 0) {
						let error = false;
						let orderDocumentItemsList = []
						let object = {};
						await this.checkedItems.forEach(el => {
							if(el.count == undefined) {
								error = true
							}
							object = {
								itemId: el.id,
								contragentOrderQty: el.count,
								comment: el.comment
							}
							orderDocumentItemsList.push(object)
						})
						if(error) {
							this.$vs.notify({
								text: 'Поле количества заказов должно быть заполнено',
								color: 'danger',
								icon: 'close',
								position: 'top-right'
							});
							return;
						}
						let payload = {
							comment: this.comment,
							status: status,
							departmentId: this.filter.contragent.id,
							orderItems: orderDocumentItemsList
						}
						//FOR EDIT BEGIN
						if(this.editRequest) {
							payload.id = this.requestItems.id
							payload.regDate = this.requestItems.regDate
							payload.regNumber = this.requestItems.regNumber
						}
						//FOR EDIT END
						await this.createFunction(payload)

					}else {
						this.$vs.notify({
						text: 'Пожалуйста, выберите товари',
						color: 'warning',
						icon: 'close',
						position: 'top-right'
						});
					}
				}else {
					this.$vs.notify({
					text: this.$t('Please select department!'),
					color: 'warning',
					icon: 'close',
					position: 'top-right'
					});
				}
			},
			async createFunction(payload) {
				try {
					let res = await ContrAgentService.createOrder(payload)
					await this.$vs.notify({
						text: res.data.status == 'PENDING'?'Заявка отправлена': 'Заявка приостановить',
						color: 'success',
						icon: 'close',
						position: 'top-right'
					});
					await this.cancel()
				} catch (e) {
					if(e.request) {
						let message = JSON.stringify(e.request.response.message)
							this.$vs.notify({
							text: 'Error: ' + message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					}
				}

			},
			loadBrands() {
				ReferencesService.getReferenceChildren(`item_brand`).then(response => {
					this.brands = response.data;
				})
			},
			reloadList() {
				this.createModal = false;
				this.mode = 'create';
				this.item = null;
				this.uploadModal = false;
			},
			close() {
				this.createModal = false;
				this.mode = 'create';
				this.item = null;
				this.uploadModal = false;
			},
			setCompanyType() {
				this.companyType = TokenService.getDepartmentType()
			},
			createNewTovar(item = null, mode = 'create') {
				this.item = item;
				this.mode = mode;
				setTimeout(() => {
					this.createModal = true
				}, 100);
			},
			filterPage() {
				this.isFilterOpen = !this.isFilterOpen
			},
			async deleteFromCheckedItems(index, item) {
				await this.checkedItems.splice(index, 1)
				await this.checkHasItem(item)
			},
			async escapeClicked() {
				await this.hideSearchResult();
			},
			hideSearchResult() {
				if (this.$refs.withKeyboardControl) {
					this.$refs.withKeyboardControl.removeKeyHandler();
				}
			},
			async selectedHandler(selectedIndex) {
				this.currentIndex = selectedIndex;
				if (this.items.length > 0) {
					await this.addToCart(this.items[selectedIndex]);
				}
			},
			async addToCart(item) {
				let equal = false
				// item.count = 0
				let indexTemp = null
				this.checkedItems.forEach((el, index) => {
					if(el.id == item.id) {
						equal = true
						indexTemp = index
					}
				})
				if(!equal) {
					this.checkedItems.unshift(item)
				}else {
					await this.checkedItems.splice(indexTemp, 1)
					await this.checkHasItem(item)
				}
			},
			contragentSelectedOption (contragent) {
				return contragent.fullName
			},
			createZoyavku() {
			},

			async searchKeywordFilter(filter) {
				if(filter == 'filter') {
					this.page = 1
				}
				let payload = {
						page: this.page,
						limit: 20,
						attributes: {
							brandId: this.filter.brandId,
							name:this.filter.name,
							barcode:this.filter.barcode
						}
					}
					GoodsService.fetchGoods(payload).then(response => {
						this.items = response.data.items;
						this.pagesTotal = Math.ceil( response.data.total / 20)
					}).catch(() => {
					})
			},
			async cancel() {
				await this.$emit('close', false);
			},
			// loadContragents() {
			// 	ContrAgentService.search({
			// 		page: 1, limit: 700
			// 	}).then(response => {
			// 		this.dropdowns.counterparties = response.data.items;
			// 		if(this.editRequest) {

			// 		}
			// 	})
			// },
			...mapActions('departments', [
				'fetchMyDepartments', 'updateOrCreateChildDep', 'deleteDep'
			]),
			loadCheckedItemsForEdit() {
				let array = []
				let obj = {};
				this.requestItems.orderItems.forEach(el => {
					obj = {
						id:el.itemId,
						name: el.itemName,
						barcode: el.itemBarcode,
						count: el.contragentOrderQty,
						artikul: el.itemArtikul,
						unitName: el.unitName,
						colorName: el.itemColor,
						edit: true
					}
					array.push(obj)
				})
				this.comment = this.requestItems.comment
				this.checkedItems = array
			},
			setDepartmentIfModeEdit() {
				this.transferPermittedDepartments.forEach(el => {
							if(el.id == this.requestItems.departmentId) {
								this.filter.contragent =  el
							}
						})
			}
		},
		async created() {
			await this.fetchMyDepartments();
			await this.setCompanyType();
			await this.loadBrands()
			if(this.editRequest) {
				await this.loadCheckedItemsForEdit()
				await this.setDepartmentIfModeEdit()
			}
		}

	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
	#searchResult {
		background: white;
		z-index: 101;
		max-height: 18rem;
		overflow-x: auto;
		.foundProduct {
			border-top:0.1px solid #c8ced3;
			padding: 6px;
			font-size: 12px;
			cursor: pointer;
			&:hover {
				background: #e0e7ec;
			}
			.productName {
				padding-right: 1rem;
				font-size: 12px;
			}

			.productPrice {
				font-size: 13px;
				width: 32%;
			}

			.productBreadcrumb {
				font-size: 12px;
				color: #888;
			}
		}
	}
	.foundProduct {
		&.disabled {
			background-color: white;
		}

		&.selected {
			background-color: #ccc;
		}
	}
	@media (min-width: 1624px) {
		#searchResult {
			width: 93.495%;
			left: 3.41%;
		}
	}
	tr td {
		vertical-align: middle;
	}
	.trash:hover {
		cursor: pointer;
		opacity: 0.5;;
	}
	.dd {
		background: #e0e7ec
	}
	.dd2 {
		background: red
	}
	.editBg {
		background: #e0e7ec;
	}
		/* width */
	::-webkit-scrollbar {
	width: 15px;
	height:15px;
	}

	/* Track */
	::-webkit-scrollbar-track {
	box-shadow: inset 0 0 5px grey;
	//   border-radius: 10px;
	}

	/* Handle */
	::-webkit-scrollbar-thumb {
	background: #e0e7ec;
	//   border-radius: 10px;
	}

	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
	background: #e0e7ec;
	}
</style>
